import { render, staticRenderFns } from "./Answers.vue?vue&type=template&id=6cf20af3&scoped=true"
import script from "./Answers.vue?vue&type=script&lang=js"
export * from "./Answers.vue?vue&type=script&lang=js"
import style0 from "./Answers.vue?vue&type=style&index=0&id=6cf20af3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf20af3",
  null
  
)

export default component.exports